<app-tablelayout [data]="logs" [filterItems]="filterOptions" [count]="count" [columnsToRemove]="removeColumn" [offset]="25" [allowExport]="true"
    (loadDataEvent)="loadDataEventHandler($event)"><app-tablelayout/>